import { useRef, useCallback } from "react";

/**
 * useSafeBackdropClose — returns props for the "modal overlay" wrapper
 * so it only closes when the ORIGINAL mousedown happened on the backdrop
 * itself. Fixes the common bug where dragging a text selection inside
 * an input past the modal edge ends the mouseup on the overlay and
 * accidentally dismisses the modal.
 *
 * Usage:
 *   const backdrop = useSafeBackdropClose(onClose);
 *   <div className="modal-overlay" {...backdrop}>
 *     <div className="modal-card" onMouseDown={(e) => e.stopPropagation()}>
 *       ...
 *     </div>
 *   </div>
 */
export function useSafeBackdropClose(onClose) {
  const startedOnBackdropRef = useRef(false);
  const onMouseDown = useCallback((e) => {
    startedOnBackdropRef.current = e.target === e.currentTarget;
  }, []);
  const onClick = useCallback((e) => {
    if (startedOnBackdropRef.current && e.target === e.currentTarget) {
      onClose && onClose();
    }
    startedOnBackdropRef.current = false;
  }, [onClose]);
  return { onMouseDown, onClick };
}
